export const BRAND_DETAIL_SECTIONS = [
  { key: "overview", label: "Overview" },
  { key: "strategy", label: "Strategy" },
  { key: "visualUniverse", label: "Visual Universe" },
  { key: "imageQa", label: "Image QA" },
  { key: "facts", label: "Facts" },
  { key: "pages", label: "Pages" },
  { key: "assets", label: "Assets" },
] as const;

export type BrandDetailSection = (typeof BRAND_DETAIL_SECTIONS)[number]["key"];

export const getBrandDetailSectionLabels = (): string[] =>
  BRAND_DETAIL_SECTIONS.map((section) => section.label);

export const isBrandDetailSection = (value: string): value is BrandDetailSection =>
  BRAND_DETAIL_SECTIONS.some((section) => section.key === value);
